var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002161",
  d: "M7.5 4.002 4 4l.002 3.498-4 .002L0 0h7.5zM32 7.5 31.998 0H24.5v4.002l3.5.002.002 3.498zm-32 17v7.498h7.5v-4L4 27.996v-3.498zm24.5 7.498h7.498V24.5L28 24.502V28l-3.5-.002zM18.5 21V11h-5v10zM20.25-.002 11.75 0v4.002L20.25 4zm0 28-8.5.002v4l8.5-.002zM-.002 11.748v8.502l4-.002v-8.502zM28 11.75v8.502l3.998-.002v-8.502z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export { SvgLogo as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.20b2c903b84e1ae0e1cc.svg";